(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pe-preview-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pe-preview-button')) {
    customElements.define('pe-preview-button', class extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick(event) {
        const link = event.target.closest('.pe-preview-button__link');
        if (!link || !this.contains(link) || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        const sectionId = this.dataset.sectionId;
        const scope = document.getElementById(`MainProduct-${sectionId}`) || this.closest('.shopify-section');
        if (!scope) return;

        const gallery = Array.from(scope.querySelectorAll('media-gallery')).find(element => {
          return element.dataset.section === sectionId && element.getClientRects().length > 0;
        });
        if (!gallery) return;

        event.preventDefault();
        const activeInput = document.activeElement;
        if (scope.contains(activeInput) && activeInput.matches('input, textarea, [contenteditable="true"]')) activeInput.blur();

        document.querySelector('sticky-header')?.dispatchEvent(new Event('preventHeaderReveal'));

        requestAnimationFrame(() => {
          if (!this.isConnected || !gallery.isConnected) return;
          const preview = gallery.querySelector('.preview-canvas-container, .preview-image-container, .product__media-item--previewElement');
          const slide = preview?.closest('.product__media-item[data-media-id]');
          if (slide && gallery.contains(slide) && !slide.classList.contains('is-active')) {
            const thumbnail = Array.from(gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]'))
              .find(element => element.dataset.target === slide.dataset.mediaId);
            if (thumbnail?.querySelector('button')) {
              thumbnail.querySelector('button').click();
            } else if (!gallery.querySelector('[id^="GalleryThumbnails"]') && typeof gallery.setActiveMedia === 'function') {
              gallery.setActiveMedia(slide.dataset.mediaId, false);
            }
          }

          requestAnimationFrame(() => {
            if (!this.isConnected || !gallery.isConnected) return;
            const headerHeight = Array.from(document.querySelectorAll('#shopify-section-header, .shopify-section-header-sticky, sticky-header'))
              .reduce((height, header) => Math.max(height, header.getBoundingClientRect().height), 0);
            const extraOffset = Number(this.dataset.scrollOffset) || 0;
            const scrollTop = Math.max(0, gallery.getBoundingClientRect().top + window.scrollY - headerHeight - extraOffset);

            if (!gallery.hasAttribute('tabindex')) {
              gallery.setAttribute('tabindex', '-1');
              gallery.addEventListener('blur', () => gallery.removeAttribute('tabindex'), { once: true });
            }
            gallery.focus({ preventScroll: true });
            window.scrollTo({
              top: scrollTop,
              left: window.scrollX,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
            });
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
